import React, { FunctionComponent, useEffect, useState } from "react";
import LoadingModal from "./loadingModal";

interface ExtendedLoadingModalProps {
  translate: (code: string) => string;
  isLoading: boolean;
  isBusy: boolean;
  minDuration?: number; // in milliseconds, default 5000ms
}

const ExtendedLoadingModal: FunctionComponent<ExtendedLoadingModalProps> = ({
  translate,
  isLoading,
  isBusy,
  minDuration = 1500,
}) => {
  const [shouldShow, setShouldShow] = useState(false);
  const [startTime, setStartTime] = useState<number | null>(null);

  useEffect(() => {
    if (isLoading || isBusy) {
      // Show loading immediately when needed
      if (!shouldShow) {
        setShouldShow(true);
        setStartTime(Date.now());
      }
    } else {
      // Both isLoading and isBusy are false, check if minimum time has passed
      if (shouldShow && startTime) {
        const elapsed = Date.now() - startTime;
        if (elapsed >= minDuration) {
          // Minimum time has passed, hide immediately
          setShouldShow(false);
          setStartTime(null);
        } else {
          // Wait for the remaining time
          const remainingTime = minDuration - elapsed;
          const timeoutId = setTimeout(() => {
            setShouldShow(false);
            setStartTime(null);
          }, remainingTime);

          return () => clearTimeout(timeoutId);
        }
      }
    }
  }, [isLoading, isBusy, shouldShow, startTime, minDuration]);

  return <LoadingModal translate={translate} isVisible={shouldShow} />;
};

export default ExtendedLoadingModal;
